import mapBoxGl from 'mapbox-gl';
import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
//Models
import AppModel from './App/model.js';

const showAlert = AppModel.showAlert;
const correctPopupPosition = AppModel.correctPopupPosition;
mapBoxGl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN;

let CARD_W = 350; //fixed card width
let GAP = 20; // spaceBetween

// Pad the end so the last 350px card can fully snap into view
function adjustOffsets(sw) {
  const w = sw.width;
  const slidesCount = sw.slides.length;

  // how many cards can we show per view
  let perView;
  if (sw.params.slidesPerView === 'auto') {
    perView = Math.max(1, Math.floor((w + GAP) / (CARD_W + GAP)));
  } else {
    perView = sw.params.slidesPerView;
  }

  // do all slides fit in the viewport?
  const totalWidth = slidesCount * CARD_W + (slidesCount - 1) * GAP;
  const allFit = totalWidth <= w || slidesCount <= perView;

  // show/hide nav
  const $nav = $('.custom-button-prev, .custom-button-next');
  $nav.toggle(!allFit);

  const used = perView * CARD_W + (perView - 1) * GAP;
  let leftover = Math.max(0, w - used);
  if (leftover < 50) leftover = 0;

  sw.params.slidesOffsetAfter = leftover;
  sw.update();
}

// update swiper navigation buttons state
function updateNav(swiper) {
    const $prev = $('.custom-button-prev');
    const $next = $('.custom-button-next');

    // if content fits in viewport, Swiper is "locked"
    const showNav = !swiper.isLocked;

    $prev.toggle(showNav);
    $next.toggle(showNav);

    if (!showNav) return; // nothing to update

    $prev.prop('disabled', swiper.isBeginning);
    $next.prop('disabled', swiper.isEnd);
    $prev.toggleClass('is-disabled', swiper.isBeginning);
    $next.toggleClass('is-disabled', swiper.isEnd);
}

// Remove dividers from the first element of each row except the first row
function removeFirstRowDividers() {
    const $container   = $('.ad-attributes');
    const $children    = $container.children();
    const firstRowTop  = $children.first().position().top;
    
    $children.filter('.divider').each(function () {
      const $divider    = $(this);
      const dividerTop  = $divider.position().top;
    
      // Not in first row?
      const notFirstRow = dividerTop > firstRowTop;
    
      // Any previous sibling on the same row?
      const hasPrevSameRow = $divider.prevAll().filter(function () {
        return $(this).position().top === dividerTop;
      }).length > 0;
    
      // First element of its row & not in first row → hide it
      if (notFirstRow && !hasPrevSameRow) {
        $divider.hide(); // or addClass('hidden')
      }
    });
}

$(document).ready(function(){

    /***************** Utilities Functions *****************/
    // initialize the mapbox map
    function initMap() {
        const bounds = [
            [-5.4534286, 41.2632185],
            [9.8678344, 51.268318],
        ];

        const map = new mapBoxGl.Map({
            container: 'location-map',
            style: 'mapbox://styles/mapbox/outdoors-v12',
            language: 'fr',
            center: [long, lat],
            zoom: zoom,
            minZoom: 4,
            maxZoom: 17,
            maxBounds: bounds,
            locale: {
                'AttributionControl.ToggleAttribution': 'Basculer l\'attribution',
                'AttributionControl.MapFeedback': 'Commentaires sur la carte',
                'FullscreenControl.Enter': 'Entrer en plein écran',
                'FullscreenControl.Exit': 'Quitter le plein écran',
                'GeolocateControl.FindMyLocation': 'Rechercher ma position',
                'GeolocateControl.LocationNotAvailable': 'Localisation non disponible',
                'LogoControl.Title': 'Logo Mapbox',
                'Carte.Titre': 'Carte',
                'NavigationControl.ResetBearing': 'Réinitialiser le relèvement vers le nord',
                'NavigationControl.ZoomIn': 'Zoom avant',
                'NavigationControl.ZoomOut': 'Zoom arrière',
                'ScrollZoomBlocker.CtrlMessage': 'Utilisez ctrl + défilement pour zoomer sur la carte',
                'ScrollZoomBlocker.CmdMessage': 'Utilisez ⌘ + défilement pour zoomer sur la carte',
                'TouchPanBlocker.Message': 'Utilisez deux doigts pour déplacer la carte'
            }
        });

        const $markerElement = $('<img class="marker" src="/assets/mapboxgl_selected_marker.webp"/>');
        new mapBoxGl.Marker({
            element: $markerElement[0],
        })
        .setLngLat([long, lat])
        .addTo(map);
    }

    function initImagesSwiper(){
        new Swiper('.swiper', {
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: '.custom-button-next',
                prevEl: '.custom-button-prev',
            },
            on: {
                navigationNext: function () {
                    $('#current-slide').html(this.realIndex + 1);
                },
                navigationPrev: function () {
                    $('#current-slide').html(this.realIndex + 1);
                },
            },
        });
    }

    function initSimilarAdsSwiper(){
        // initialize real estate ads swiper
        new Swiper(".properties-slider", {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 16, 
            // centeredSlides: false,
            centeredSlidesBounds: true,      // keeps first/last nicely aligned
            centerInsufficientSlides: false,  // center if fewer slides than viewport
            watchOverflow: true,             // disable if not enough slides to scroll
            modules: [Navigation],
            navigation: {
                nextEl: '.custom-button-next',
                prevEl: '.custom-button-prev',
            },
            on: {
                init() { adjustOffsets(this); updateNav(this); },
                resize() { adjustOffsets(this); },
                slideChange() { updateNav(this); },
                update() { updateNav(this); },
            },
            breakpoints: {
                430: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 2.5
                },
                1280: {
                    spaceBetween: 16,
                    slidesPerView: 2.5
                }
            }
        });
    }


    //init the map if the location map element exists
    if($('#location-map').length > 0) initMap();

    initImagesSwiper();
    initSimilarAdsSwiper();
    removeFirstRowDividers();

    /***************** Global Variables *****************/
    let showPhoneNumber = false;
    let phoneNumber = null;

    /***************** Event Handlers *****************/
    $(document).on('click',function(e) {
        const $target = $(e.target);
        const $socials = $('.socials');
        const $shareBtn = $('.share-btn');
        const $shareBtnMobile = $('.share-btn-mobile');

        // Close the share dropdown if the user clicks outside of it
        if (!$shareBtn.is($target) && 
        $shareBtn.has($target).length === 0) {
            $shareBtn.removeClass('open');
            $socials.removeClass('flex flex-col gap-2')
            .addClass('hidden');
        }

        // close the share dropdown on mobile
        if (!$shareBtnMobile.is($target) &&
        $shareBtnMobile.has($target).length === 0) {
            $shareBtnMobile.find('.socials-mobile')
            .removeClass('flex flex-col gap-2')
            .addClass('hidden');
        }

        // Hide the alert modal
        if($target.is('#create-alert-modal')){
            $target.removeClass('grid place-items-center')
            .addClass('hidden');
        }

        // Hide the report ad modal
        if($target.is('#report-ad-modal')){
            $target.removeClass('grid place-items-center')
            .addClass('hidden');
        }
    });

    // Show phone number and copy it to clipboard
    $('#owner-phone').on('click', function(){
        //prevent redirect to the property details page
        event.preventDefault();
        const $btn = $(this);
        const getOwnerPhoneUrl = $btn.data('route');
        const showPhoneNumber = $btn.data('show-phone') ;
        const $copied = $btn.find('.copied');
        const $callMe = $btn.find('.call-me');

        // show phone number
        if(showPhoneNumber == '0'){
            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                url: getOwnerPhoneUrl,
                type: 'GET',
                dataType: 'json',
                context: this,
                success: function (response) {
                    if(response.status == 200){
                        $callMe.text(response.phone);
                        $btn.data('phone', response.phone);
                        $btn.data('show-phone', '1');
                    }else{
                        showAlert('retrieving phone number failed', 'error');
                    }
                },
                error: function(error){
                    showAlert('retrieving phone number failed', 'error');
                    console.error(error.message);
                }
            });
        }else{
            // Create a temporary input element to copy the text
            const tempInput = $('<input>');
            $('body').append(tempInput);
            tempInput.val($btn.data('phone')).select();
            document.execCommand('copy');
            tempInput.remove();
            $callMe.hide();
            $copied.fadeIn(
                function(){
                    setTimeout(function(){
                        $copied.fadeOut(function() {
                            $callMe.show();
                        });
                    }, 1000);
                }
            );
        }
    });

    // handle the sharing of the property on social media
    $('.share-btn').on('click', function(){
        const $btn = $(this);

        if($btn.hasClass('open')){
            $btn.removeClass('open');
            $btn.find('.socials')
            .removeClass('flex flex-col gap-2')
            .addClass('hidden');
        }else{
            $btn.addClass('open');
            $btn.find('.socials')
            .addClass('flex flex-col gap-2')
            .removeClass('hidden');
        }
    });

    // handle the sharing of the property on social media on mobile
    $('.share-btn-mobile').on('click', function(){
        const $btn = $(this);
        $btn.find('.socials-mobile').toggleClass('hidden flex flex-col gap-2');
    });
     // Share on Facebook
     $('.share-facebook').on('click',function(e) {
        e.preventDefault();
        const url = encodeURIComponent(window.location.href);
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        window.open(shareUrl, '_blank', 'width=600,height=400');
    });

    // Share on Twitter/X
    $('.share-twitter').on('click' ,function(e) {
        e.preventDefault();
        const url = encodeURIComponent(window.location.href);
        const text = encodeURIComponent(document.title);
        const shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
        window.open(shareUrl, '_blank', 'width=600,height=400');
    });

    // copy the property link to clipboard
    $('.copy-link').on('click', function(e){
        e.preventDefault();
        const url = window.location.href;
        const tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(url).select();
        document.execCommand('copy');
        tempInput.remove();
        showAlert('Lien copié dans le presse-papiers');
    });

     // show alert modal
     $('#create-alert-btn').on('click', function () {
        $('#create-alert-modal').removeClass('hidden')
        .addClass('grid place-items-center');
    });

    // handling report ad module and submission
    $('#open-report-ad-modal').on('click', function () {
        $('#report-ad-modal').removeClass('hidden')
        .addClass('grid place-items-center');;
    });
    
    $('#close-report-ad-modal').on('click', function () {
        $('#report-ad-modal').removeClass('grid place-items-center')
        .addClass('hidden');
    });
    
    $('#report-ad-form').on('submit', function (e) {        
        e.preventDefault();
        const $form = $(this);

        $form.find('.error').empty();

        $.ajax({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            context: this,
            data: {
                property_id: $form.find('#property_id').val(),
                email: $form.find('input[name="email"]').val(),
                comment: $form.find('textarea[name="comment"]').val()
            },
            success: function (response) {
                showAlert(response.message);
                $('#report-ad-modal').addClass('hidden');
            },
            error: function(error) {

                if(error.responseJSON){
                    const errors = error.responseJSON.errors;
    
                    // loop through validation errors
                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            const errorMessages = errors[key];
                            const $errorsList = $form.find(`#${key}_error`);
                            $errorsList.empty();
                            errorMessages.forEach(message => {
                                $errorsList.append(`<li>${message}</li>`);
                            });
                        }
                    }
                }
            },

        });
    });

    // handling the property images slider
    $('.open-slider').on('click', function (e) {
        $(window).scrollTop(0);
        $("body").css("overflow", "hidden");
        $('.property-images-slider').removeClass('hidden');
    });
    
    $('.close-slider').on('click', function (e) {
        $("body").css("overflow", "");
        $('.property-images-slider').addClass('hidden');
    });

    // Favorites Control
    $('.fav-button').on('click', function () {
        $.ajax({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            url: $(this).data('fav-url'),
            type: 'POST',
            dataType: 'json',
            context: this,
            success: function (response) {
                $(this).find('i')
                    .toggleClass('fa-solid fa-regular text-red-600')
                    .data('fav-url', response.data.fav_url);

                showAlert(response.message);
            },
            error: function (error) {                
                if(error.responseJSON && error.responseJSON.data){
                    window.location.href = error.responseJSON.data.redirect;
                }
            }
        });
    });
    
    //contact the owner
    $('#contact-owner button[type="submit"]').on('click', function (e) {
        e.preventDefault();

        const $form = $(this).closest('form');
        const url = $form.attr('action');
        
        // set the phone number value
        const $phone = $form.find('#phone');
        $phone.val(iti.getNumber(intlTelInput.utils.numberFormat.INTERNATIONAL));        

        const payload = $form.serialize();
        const $submitButton = $(this);
        const submitButtonText = $submitButton.data('sending-text') ?? 'Soumettre ...';

        // clear all validation errors
        $form.find('.error').empty();

        $submitButton.text(submitButtonText);
        $submitButton.prop('disabled', true);

        $.ajax({
            headers: { 'X-CSRF-TOKEN': $form.find('input[name="_token"]').val() },
            url: url,
            type: 'POST',
            data: payload,
            dataType: 'json',
            context: this,
            success: function (response) {
                if(response.status === 200){
                    showAlert(response.message);
                }else{
                    showAlert(response.message, 'error');
                }
            },
            error: function(error) {
                const errors = error.responseJSON.errors;

                // loop through validation errors
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        const errorMessages = errors[key];
                        const $errorsList = $form.find(`#${key}_error`);
                        $errorsList.empty();
                        errorMessages.forEach(message => {
                            $errorsList.append(`<li>${message}</li>`);
                        });
                    }
                }
            },
            complete: function(){
                $submitButton.text($submitButton.attr('aria-label'));
                $submitButton.prop('disabled', false);
            }
        });
    });

    $('.more-info').on('mouseenter', function(){
        const tooltipId = $(this).find('.tooltip').attr('id');
        correctPopupPosition(tooltipId);
    });

    $('#contact-owner-navigate-btn').on('click', function(e){
        $('html, body').animate({
            scrollTop: $("#contact-owner-container").offset().top
        }, 1000);
    });
});
